var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4C11.4477 4 11 3.55229 11 3V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V3C13 3.55229 12.5523 4 12 4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6569 6.34315C17.2663 5.95262 17.2663 5.31946 17.6569 4.92894L19.0711 3.51472C19.4616 3.1242 20.0948 3.1242 20.4853 3.51472C20.8758 3.90525 20.8758 4.53841 20.4853 4.92894L19.0711 6.34315C18.6806 6.73367 18.0474 6.73367 17.6569 6.34315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11C20.4477 11 20 11.4477 20 12C20 12.5523 20.4477 13 21 13H23C23.5523 13 24 12.5523 24 12C24 11.4477 23.5523 11 23 11H21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6569 17.6569C18.0474 17.2663 18.6806 17.2663 19.0711 17.6569L20.4853 19.0711C20.8758 19.4616 20.8758 20.0948 20.4853 20.4853C20.0948 20.8758 19.4616 20.8758 19.0711 20.4853L17.6569 19.0711C17.2663 18.6805 17.2663 18.0474 17.6569 17.6569Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C11.4477 24 11 23.5523 11 23V21C11 20.4477 11.4477 20 12 20C12.5523 20 13 20.4477 13 21V23C13 23.5523 12.5523 24 12 24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51472 3.51472C3.90524 3.1242 4.53841 3.1242 4.92893 3.51472L6.34315 4.92894C6.73367 5.31946 6.73367 5.95263 6.34315 6.34315C5.95262 6.73368 5.31946 6.73368 4.92893 6.34315L3.51472 4.92894C3.1242 4.53841 3.1242 3.90525 3.51472 3.51472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51472 20.4853C3.1242 20.0948 3.1242 19.4616 3.51472 19.0711L4.92894 17.6569C5.31946 17.2663 5.95263 17.2663 6.34315 17.6569C6.73368 18.0474 6.73368 18.6805 6.34315 19.0711L4.92894 20.4853C4.53841 20.8758 3.90525 20.8758 3.51472 20.4853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 11.4477 0.447715 11 1 11H3C3.55229 11 4 11.4477 4 12C4 12.5523 3.55229 13 3 13H1C0.447715 13 0 12.5523 0 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.105ffe0ffe1841f3e9450c560bc1982f.svg";
export { ForwardRef as ReactComponent };